import request from './request'

// 合伙人列表查询（分页）
export function getPartnerList (params) {
  return request({
    url: '/admin/partner/list',
    method: 'get',
    params
  })
}

// 新增合伙人
export function addPartner (data) {
  return request({
    url: '/admin/partner/add',
    method: 'post',
    data
  })
}

// 编辑合伙人信息
export function updatePartner (data) {
  return request({
    url: '/admin/partner/update',
    method: 'put',
    data
  })
}

// 删除合伙人
export function deletePartner (partnerId) {
  return request({
    url: `/admin/partner/delete/${partnerId}`,
    method: 'delete'
  })
}

// 禁用合伙人
export function disablePartner (partnerId) {
  return request({
    url: `/admin/partner/disable/${partnerId}`,
    method: 'put'
  })
}

// 启用合伙人
export function enablePartner (partnerId) {
  return request({
    url: `/admin/partner/enable/${partnerId}`,
    method: 'put'
  })
}
